var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppdeviation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    rx: 10,
    fill: "#FCD7AD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 3.41666C6.59001 3.41666 3.41667 6.58999 3.41667 10.5C3.41667 14.41 6.59001 17.5833 10.5 17.5833C14.41 17.5833 17.5833 14.41 17.5833 10.5C17.5833 6.58999 14.41 3.41666 10.5 3.41666ZM10.5 16.1667C7.37626 16.1667 4.83334 13.6237 4.83334 10.5C4.83334 7.37624 7.37626 4.83332 10.5 4.83332C13.6238 4.83332 16.1667 7.37624 16.1667 10.5C16.1667 13.6237 13.6238 16.1667 10.5 16.1667ZM13.4538 12.455L12.6746 11.6758C13.1775 10.7337 13.05 9.54374 12.2567 8.75041C11.7679 8.26166 11.1375 8.02082 10.5 8.02082C10.4788 8.02082 10.4575 8.02791 10.4363 8.02791L11.2083 8.79999L10.4575 9.55082L8.45292 7.54624L10.4575 5.54166L11.2083 6.29249L10.5283 6.97249C11.4279 6.97957 12.3204 7.31249 13.0075 7.99249C14.2117 9.20374 14.3604 11.0808 13.4538 12.455ZM12.5471 13.4537L10.5425 15.4583L9.79167 14.7075L10.4646 14.0346C9.57209 14.0275 8.67959 13.6804 7.99959 13.0004C6.78834 11.7892 6.63959 9.91916 7.54626 8.54499L8.32542 9.32416C7.82251 10.2662 7.95001 11.4562 8.74334 12.2496C9.23917 12.7454 9.89792 12.9862 10.5567 12.965L9.79167 12.2L10.5425 11.4492L12.5471 13.4537Z",
    fill: "#5D3304"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppdeviation);
export default __webpack_public_path__ + "static/media/app.deviation.302dd8c310f31c17aabbb62a94b11fa9.svg";
export { ForwardRef as ReactComponent };